module.exports = __webpack_public_path__ + "img/IQ.a224d539.png";